import React, {Component} from "react";
import L from 'leaflet';
import {OpenStreetMapProvider, GeoSearchControl} from 'leaflet-geosearch';
import 'leaflet/dist/leaflet.css'

const provider = new OpenStreetMapProvider();
const marker_img = require('../../img/map_marker.svg');

let marker_icon = L.icon({
    iconUrl: marker_img,
    iconSize: [40, 60],
});

let marker = null;
let self = null;

let search = GeoSearchControl({
    provider,
    style: 'bar',
    showMarker: false,
    showPopup: false,
    retainZoomLevel: false,
    maxMarkers: 1,
    animateZoom: true,
    autoComplete: true,
    autoClose: true,
    searchLabel: 'Buscar',
    keepResult: true
});

function makeMarker(lat, lng, map){
    marker = L.marker([lat, lng], {
        icon: marker_icon, draggable: true
    })
        .bindPopup("<b>Tu ubicación</b>")
        .on('dragend', res => {
            self.setMarkers(res.target._latlng.lat, res.target._latlng.lng);
        }).addTo(map);
    return marker;
}

class MapSearchBox extends Component {

    constructor(props){
        super(props);
        this.state = {
            latitude: props.latitude,
            longitude: props.longitude,
        }
    }

    componentDidMount() {
        self = this;
        const map = new L.Map('map', {
            attributionControl: false,
        }).setView([this.state.latitude, this.state.longitude], 17);

        makeMarker(this.state.latitude, this.state.longitude, map);
        search.addTo(map);
        map.on('geosearch/showlocation', res => {
            map.removeLayer(marker);
            map.setView([res.location.y, res.location.x], 17);
            marker = makeMarker(res.location.y, res.location.x, map);
            this.setMarkers(res.location.y, res.location.x, map);
        });

        L.tileLayer('https://api.mapbox.com/styles/v1/jfajardo89/cjksihmxj07vf2sppo0r8qepy/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamZhamFyZG84OSIsImEiOiJjamtqMnRnemEwM2R4M2txaWl5OWM3cDZnIn0.k21R9VqBxbPZEhj68yg6ig').addTo(map);
        //L.tileLayer('http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png').addTo(map);

        if (!this.state.latitude && !this.state.longitude){
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(location => {
                    map.removeLayer(marker);
                    makeMarker(location.coords.latitude, location.coords.longitude, map);
                    self.setMarkers(location.coords.latitude, location.coords.longitude);
                    map.setView([location.coords.latitude, location.coords.longitude], 17);
                });
            }
        }
    }

    setMarkers = (lat, lng) => {
        this.props.callbackMarkers({
            lat: lat,
            lng: lng
        })
    };

    render() {
        return (
            <div id='map' style={{height: 400}}>
            </div>
        );
    }
}

export default MapSearchBox;



// WEBPACK FOOTER //
// ./src/components/extras/MapSearchBox.js